import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '../symbols';
import { isAxiosError, WorkspaceException } from '../apis/service/exception';
import { HttpServiceHelper } from './utils/HttpServiceHelper';
let WorkspaceHttp = class WorkspaceHttp extends HttpServiceHelper {
    constructor(httpClient, errorHandlerService) {
        super(errorHandlerService);
        this.httpClient = httpClient;
        this.errorHandlerService = errorHandlerService;
        this.configErrorHandler();
    }
    // #region 全局错误处理相关
    configErrorHandler() {
        this.errorHandlerService.addHandler(error => {
            if (!WorkspaceException.is(error)) {
                return false;
            }
            const workspaceError = error.response?.data;
            if (!workspaceError) {
                return false;
            }
            // todo有的错误由前端翻译处理
            this._errorDisplayProxy(workspaceError.error_message);
            return true;
        });
    }
    // #endregion
    request(config) {
        config = {
            ...config,
            params: {
                ...config?.params,
            },
            headers: {
                'X-API-Version': '1.0',
                ...config?.headers,
            },
        };
        return this.httpClient(config).then(res => res.data, error => {
            if (!isAxiosError(error)) {
                throw error;
            }
            error = WorkspaceException.mark(error);
            throw error;
        });
    }
};
WorkspaceHttp = __decorate([
    injectable(),
    __param(0, inject(Symbols.HttpClient)),
    __param(1, inject(Symbols.ErrorHandlerService)),
    __metadata("design:paramtypes", [Object, Object])
], WorkspaceHttp);
export { WorkspaceHttp };
